export const toggleChildren = (
  option: Record<string, unknown>,
  toggle: boolean,
) => {
  for (const child of option.children) {
    child.checked = toggle
    if (child.hasChildren) {
      toggleChildren(child, toggle)
    }
  }
}
export const isIndeterminate = (option: Record<string, unknown>) => {
  const areAllChecked = option.children.every((child) => child.checked === true)
  const areAllUnchecked = option.children.every(
    (child) => child.checked === false,
  )
  const areSomeChecked = option.children.some((child) => child.checked === true)
  const containsIndeterminate = option.children.some((child) => {
    if (child.children.length) {
      return isIndeterminate(child) === true
    }
  })
  if (areAllChecked || areAllUnchecked) {
    option.checked = areAllChecked
    if (containsIndeterminate) {
      return true
    }
    return false
  }
  if (areSomeChecked) {
    option.checked = true
    return true
  }
}

export function isIterableNode(_nodes) {
  return (
    Array.isArray(_nodes) &&
    _nodes.every(
      (obj) => obj instanceof Object && ('id' in obj || 'parentId' in obj),
    )
  )
}

export function convertObjectPropsToArray(object) {
  return Object.entries(object).map(([k, v]) => ({ [k]: v }))
}

export const formatNodeValue = (value: string | object, length = 30) => {
  if (typeof value === 'number') {
    return value
  }
  if (typeof value === 'string') {
    return `"${String(value).substring(0, length)}${
      String(value).length > length ? '..."' : '"'
    }`
  }
  return `${
    Array.isArray(value)
      ? `Array [${value.length}]`
      : `Object {${Object.keys(value).length}}`
  }`
}
